import radioConfig from "../config/radioConfig";

const DAY_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

function getArgentinaClock() {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: radioConfig.timeZone,
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(new Date());
  const clock = Object.fromEntries(parts.map(({ type, value }) => [type, value]));

  return {
    currentMins: Number(clock.hour) * 60 + Number(clock.minute),
    dayOfWeek: DAY_INDEX[clock.weekday],
  };
}

export function getCurrentShow(shows = []) {
  try {
    const { currentMins, dayOfWeek } = getArgentinaClock();

    for (const show of shows) {
      const scheduleStr = show.schedule || "";
      const daysStr = show.days || "";
      const parts = scheduleStr.match(/(\d{1,2}):(\d{2})\s*a\s*(\d{1,2}):(\d{2})/);
      if (!parts) continue;
      const [, sh, sm, eh, em] = parts;
      const startMins = parseInt(sh) * 60 + parseInt(sm);
      const endMins = parseInt(eh) * 60 + parseInt(em);

      if (currentMins >= startMins && currentMins < endMins) {
        if (daysStr.toLowerCase().includes("sábados") || daysStr.toLowerCase().includes("sabados")) {
          if (dayOfWeek === 6) return show;
        } else if (daysStr.toLowerCase().includes("lunes a viernes")) {
          if (dayOfWeek >= 1 && dayOfWeek <= 5) return show;
        } else {
          return show;
        }
      }
    }
    return null;
  } catch (e) {
    return null;
  }
}
